import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { fetchStudentInfo } from './api'

export const studentInfoQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentInfo', studentNo],
        queryFn: () => fetchStudentInfo(studentNo),
    })

export function useStudentInfo(studentNo: string, enabled = true) {
    return useQuery({ ...studentInfoQueryOptions(studentNo), enabled })
}

export function useStudentInfoSuspense(studentNo: string) {
    return useSuspenseQuery(studentInfoQueryOptions(studentNo))
}
